import { Component, OnInit, AfterViewInit } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";

@Component({
    templateUrl:"./managecards.component.html"
})
export class ManageCardsComponent implements OnInit, AfterViewInit{
    public pageTitle: string = 'Manage Cards';
    constructor(private authService: AuthService, private appCommonService: AppCommonService, public headerAndNavigationService: HeaderAndNavigationService) {
        this.appCommonService.pageName = this.pageTitle;
        this.appCommonService.pageContentAdditionalClass = "";
    }

    ngOnInit(): void {
      this.headerAndNavigationService.showhideNav(false, true);
    }
    
    ngAfterViewInit(): void {
        
    }
}



// WEBPACK FOOTER //
// ./src/app/managecards/managecards.component.ts